import BackgroundActivities from "../components/headers/ActivitiesHeader";
import "../components/headers/Headers.css";
import ActivitiesBody from "../components/ActivitiesBody"
import Container from '@mui/material/Container';

export default function Activities() {
    return (
    <>
    <div className="Headers">
        <BackgroundActivities />
        <Container justifyContent="center" maxWidth='md'>
            <ActivitiesBody />
        </Container>
    </div>
    </>
    )
  }